import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { recordVisit } from '@/utils/visitTracker';

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/intro' },
  { path: '/intro', name: 'intro', component: () => import('@/views/IntroView.vue') },
  { path: '/home', name: 'home', component: () => import('@/views/HomeView.vue') },
  { path: '/policies', name: 'policies', component: () => import('@/views/PoliciesView.vue') },
  { path: '/promo', name: 'promo', component: () => import('@/views/PromoView.vue') },
  { path: '/about', name: 'about', component: () => import('@/views/AboutView.vue') },
  { path: '/cases', name: 'cases', component: () => import('@/views/CasesView.vue') },
  { path: '/contact', name: 'contact', component: () => import('@/views/ContactView.vue') },
  { path: '/lead-admin', name: 'lead-admin', component: () => import('@/views/LeadAdminView.vue'), meta: { admin: true } },
  { path: '/admin/whitelist', name: 'admin-whitelist', component: () => import('@/views/AdminWhitelistView.vue'), meta: { admin: true, superAdmin: true } },
  { path: '/admin/dashboard', name: 'admin-dashboard', component: () => import('@/views/AdminDashboardView.vue'), meta: { admin: true } },
  { path: '/:pathMatch(.*)*', redirect: '/intro' }
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() { return { top: 0 }; }
});

// 路由守卫：admin 页面（含管理面板）校验白名单；superAdmin 页面（白名单管理）仅 env 超管可进
// 普通管理员（库表白名单）只能进留资查看
router.beforeEach(async (to) => {
  if (to.meta.admin || to.meta.superAdmin) {
    const { useAuthStore } = await import('@/stores/auth');
    const auth = useAuthStore();
    if (!auth.loggedIn) await auth.fetchMe();
    if (!auth.isAdmin) return { path: '/', query: { login: '1' } };
    if (to.meta.superAdmin && !auth.isSuperAdmin) return { path: '/lead-admin' };
  }
  return true;
});

/**
 * 路由级访问记录（漏洞 4 修复）
 * 此前只有首页（HomeView）调用 recordVisit，政策/案例/关于我们/联系我们等路由完全不记录，
 * 导致「访问记录」列表与统计缺失这部分流量。
 * 现统一在路由切换后上报，后端按访客标识合并为一行，不会因多次切换产生重复行。
 */
const TRACKED_ROUTES = new Set(['/home', '/intro', '/policies', '/promo', '/cases', '/about', '/contact']);
router.afterEach((to) => {
  const path = to.path;
  if (!TRACKED_ROUTES.has(path)) return;
  recordVisit({ path: path + (to.query.region ? `?region=${to.query.region}` : ''), regionCode: typeof to.query.region === 'string' ? to.query.region : undefined });
});
